import AccordionWrapper from "common/components/AccordionWrapper";
import moment from "moment";
import React from "react";

const ProfileAccordion = ({ data }) => {
  const Add = data.ParmanentAddress || {};

  let Address = "";
  if (Add)
    Address =
      (Add.line1 || "") +
      " " +
      (Add.line2 || "") +
      " " +
      (Add.line3 || "") +
      " " +
      (Add.cityname || "") +
      " ," +
      (Add.countryname || "");

  let checkAddress = String(Address).replaceAll(" ", "");

  if (checkAddress === "," || checkAddress === "undefined") {
    Address = "null";
  }

  let bankdetails = data?.bankdetails || {};
  console.log(data, "data");
  let femilyMemberFullName = data?.family_member_first_name + " " + data?.family_member_last_name;
  let documents = data?.documents || [{}];
  documents = documents[0];
  console.log(documents, "documents");
  return (
    <>
      <AccordionWrapper title={"Personal Informations"} eventKey={"#flush-collapseOne"} id={"flush-collapseOne"}>
        <div className="row">
          <div className="col-lg-12 ">
            <ul className="drawerUserDetail">
              <li className="row">
                <span className="col-lg-6">Telphone No. :</span>
                <span className="col-lg-6 text-dark-emphasis">{data.mobile_number ? data.mobile_number : "NA"}</span>
              </li>
              <li className="row">
                <span className="col-lg-6">Address :</span>
                <span className="col-lg-6 text-dark-emphasis">{Address ? Address : "NA"}</span>
              </li>
              {/* <li className="row">
                <span className="col-lg-6">Nationality :</span>
                <span className="col-lg-6 text-dark-emphasis">null</span>
              </li>
              <li className="row">
                <span className="col-lg-6">Religion :</span>
                <span className="col-lg-6 text-dark-emphasis">null</span>
              </li>
              <li className="row">
                <span className="col-lg-6">Marital status :</span>
                <span className="col-lg-6 text-dark-emphasis">null</span>
              </li>
              <li className="row">
                <span className="col-lg-6">Employment of spouse :</span>
                <span className="col-lg-6 text-dark-emphasis">null</span>
              </li>
              <li className="row">
                <span className="col-lg-6">No. of children :</span>
                <span className="col-lg-6 text-dark-emphasis">null</span>
              </li> */}
            </ul>
          </div>
        </div>
      </AccordionWrapper>
      <AccordionWrapper title={"Emergency Contact"} eventKey={"#flush-collapseTwo"} id={"flush-collapseTwo"}>
        <div className="row">
          <div className="col-lg-12 ">
            <ul className="drawerUserDetail">
              <li className="row">
                <span className="col-lg-6">Name :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {femilyMemberFullName ? femilyMemberFullName : "NA"}
                </span>
              </li>
              <li className="row">
                <span className="col-lg-6">Relationship :</span>
                <span className="col-lg-6 text-dark-emphasis">{data?.relationship ? data?.relationship : "NA"}</span>
              </li>
              <li className="row">
                <span className="col-lg-6">Phone :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {data?.family_member_phone ? data?.family_member_phone : "NA"}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </AccordionWrapper>
      <AccordionWrapper title={"Bank information"} eventKey={"#flush-collapseThree"} id={"flush-collapseThree"}>
        <div className="row">
          <div className="col-lg-12 ">
            <ul className="drawerUserDetail">
              <li className="row">
                <span className="col-lg-6">Bank Name :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {bankdetails.bank_name ? bankdetails.bank_name : "NA"}
                </span>
              </li>
              <li className="row">
                <span className="col-lg-6">Bank Account No. :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {bankdetails.account_no ? bankdetails.account_no : "NA"}
                </span>
              </li>
              <li className="row">
                <span className="col-lg-6">IFSC Code :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {bankdetails.ifsc_code ? bankdetails.ifsc_code : "NA"}
                </span>
              </li>
              <li className="row">
                <span className="col-lg-6">PAN No. :</span>
                <span className="col-lg-6 text-dark-emphasis">{data.pancard_no ? data.pancard_no : "NA"}</span>
              </li>
            </ul>
          </div>
        </div>
      </AccordionWrapper>
      <AccordionWrapper title={"Family informations"} eventKey={"#flush-collapseFour"} id={"flush-collapseFour"}>
        <div className="row">
          <div className="col-lg-12 ">
            <ul className="drawerUserDetail">
              <li className="row">
                <span className="col-lg-6">Name :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {femilyMemberFullName ? femilyMemberFullName : "NA"}
                </span>
              </li>
              <li className="row">
                <span className="col-lg-6">Relationship :</span>
                <span className="col-lg-6 text-dark-emphasis">{data?.relationship ? data?.relationship : "NA"}</span>
              </li>
              <li className="row">
                <span className="col-lg-6">Date of Birth :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {data?.family_member_dob ? moment(data?.family_member_dob).format("LL") : "NA"}
                </span>
              </li>
              <li className="row">
                <span className="col-lg-6"> Phone :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {data?.family_member_phone ? data?.family_member_phone : "NA"}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </AccordionWrapper>
      <AccordionWrapper title={"Education Information"} eventKey={"#flush-collapseFive"} id={"flush-collapseFive"}>
        <div className="row">
          <div className="col-lg-12 ">
            <ul className="drawerUserDetail">
              <li className="row">
                <span className="col-lg-6"> Secondary Passing :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {documents?.secondary_passing ? documents?.secondary_passing : "NA"}%
                </span>
              </li>
              <li className="row">
                <span className="col-lg-6"> Senior Passing :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {documents?.senior_passing ? documents?.senior_passing : "NA"}%
                </span>
              </li>
              <li className="row">
                <span className="col-lg-6"> Bachelor's Passing :</span>
                <span className="col-lg-6 text-dark-emphasis">
                  {documents?.bachelor_passing ? documents?.bachelor_passing : "NA"}%
                </span>
              </li>
              {documents.extra &&
                documents.extra.map((extraDetail, index) => {
                  return (
                    <>
                      <li className="row">
                        <span className="col-lg-6"> {extraDetail?.degreeField} :</span>
                        <span className="col-lg-6 text-dark-emphasis">
                          {extraDetail?.degreepercent ? extraDetail?.degreepercent : "NA"}%
                        </span>
                      </li>
                    </>
                  );
                })}
            </ul>
          </div>
        </div>
      </AccordionWrapper>
    </>
  );
};

export default ProfileAccordion;
